// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

import './css/styles.css'


// JS
//import "./js/index.js"

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

window.Alpine = Alpine
Alpine.plugin(collapse)

Alpine.start()

// Image Slideshow blocks — one Swiper per [data-swiper] container.
function initSwipers() {
    document.querySelectorAll('[data-swiper]').forEach((el) => {
        new Swiper(el, {
            modules: [Navigation],
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                prevEl: el.querySelector('.ow-slideshow__prev'),
                nextEl: el.querySelector('.ow-slideshow__next'),
            },
        })
    })
}

if (document.readyState !== 'loading') {
    initSwipers()
} else {
    document.addEventListener('DOMContentLoaded', initSwipers)
}

// Profiles Index (Sprig) — on mobile, after paging the bottom pager swaps the
// grid in place but leaves the viewport scrolled to the bottom. Scroll the
// listing back to the top so the new page of results starts in view. Desktop
// keeps its scroll position (the pager sits at the top there).
document.addEventListener('htmx:afterSwap', (event) => {
    const trigger = event.detail?.requestConfig?.elt
    if (!trigger?.closest('.ow-pager')) return

    if (window.matchMedia('(min-width: 768px)').matches) return

    const section = event.detail.target.closest('.ow-profiles')
    section?.scrollIntoView({ block: 'start' })
})